/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：992
 */

var r = require(/* 502 */"../../../../../2588/1461/2585/502/index")
var i = require(/* 2473 */"./2473")
var o = exports && !exports.nodeType && exports
var a = o && "object" == typeof module && module && !module.nodeType && module
var s = a && a.exports === o ? r.Buffer : undefined
var c = (s ? s.isBuffer : undefined) || i
module.exports = c
